// extracted by mini-css-extract-plugin
export var imageWrapperStyle = "featured_person_landscape-module--imageWrapperStyle--fFrc+";
export var profilePictureStyle = "featured_person_landscape-module--profilePictureStyle--XlFuU";
export var rightContentStyle = "featured_person_landscape-module--rightContentStyle--eDIEw";
export var textWrapperStyle = "featured_person_landscape-module--textWrapperStyle---Tbly";
export var wrapperStyle = "featured_person_landscape-module--wrapperStyle--60x4u";